import React from "react";
import { Checkbox } from "@material-ui/core";

const InputCheckbox = (props) => {
  return (
    <Checkbox
      checked={props.value == "0" ? false : true}
      style={{ width: "99%" }}
      onChange={(e) =>
        props.Change_Data(props.data_key, e.target.checked == true ? 1 : 0)
      }
    />
  );
};

export default InputCheckbox;
